import React, { useEffect } from "react"
import { useState } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { addSlideSchema } from "components/Common/validation"
import Switch from "components/Shared/Switch"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import {
  addSlide,
  getSlideDetails,
  updateSlide,
} from "store/actions/bannerAction"
import SweatAlert from "components/Shared/SweatAlert"
import Spinners from "components/Shared/Spinners"
import { showAlert } from "store/reducers/alertReducer"
import Breadcrumbs from "components/Common/Breadcrumb"
import isPermissionEnabled from "common/isPermissionEnabled"
import { getCategories } from "store/actions/categoriesAction"
import Select from "react-select"
import { getItemsList, getItemsListDropdown } from "store/actions/itemsAction"
import BackButton from "components/Shared/BackButton"
import { useTranslation } from "react-i18next"
import { setImageCompressing } from "store/reducers/commonReducer"
import imageCompression from "browser-image-compression"
import { bannerHeight, bannerWidth } from "components/Common/ImageSize"
import TextError from "components/Shared/TextError"

const initialValues = {
  imageType: "UPLOAD",
  imageURL: "",
  imageFile: null,
  applySameImageOnBothLang: true,
  imageUrlTypeAr: "UPLOAD",
  imageUrlAr: "",
  hasAdvancedSettings: false,
  title: "",
  titleAr: "",
  description: "",
  descriptionAr: "",
  linkLabel: "",
  linkLabelAr: "",
  linkValue: "",
  linkType: "",
  category: "",
  item: "",
  imageAr: "",
  label: "",
  displayOrder: 0,
}

const AddSlide = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${mode === "add" ? t("Add") : t("Edit")} ${t(
    "Slide | Sign Burger"
  )}`

  const { bannerId } = useParams()
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const countryCode = searchParams.get("countryCode")
  const [formValues, setFormValues] = useState(initialValues)
  const { allCategories } = useSelector(state => state.Categories)
  const { isImageCompressing } = useSelector(state => state.Common)

  const {
    loading,
    error,
    isLoading,
    isUpdating,
    message,
    actionType,
    slideDetails,
  } = useSelector(state => state.Banners)

  const { itemsLists } = useSelector(state => state.Items)
  const { itemsListDropdown } = useSelector(state => state.Items)
  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    getCategoriesList()
  }, [])

  const getCategoriesList = () => {
    dispatch(getCategories({ isCombo: false, countryCode }))
  }

  const getItems = categoryId => {
    const payload = {
      perPage: 100,
      pageNo: 1,
      status: 2,
      orderBy: 1,
      keyword: "",
      category: [categoryId],
    }
    dispatch(getItemsList(payload))
  }
  const allItemsList = value => {
    const payload = {
      category: value ? [value] : [],
    }
    dispatch(getItemsListDropdown(payload))
  }

  useEffect(() => {
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      2,
      "inAppContent_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(userRole, 2, "inAppContent_3")
    if (mode === "add") {
      if (!isPermissionCreate) {
        navigate("/dashboard")
      }
    } else if (mode === "edit") {
      if (!isPermissionEdit) {
        navigate("/dashboard")
      }
    }
  }, [])

  // IF HAVE MODE===EDIT THEN UPDATE INITAIL VALUES
  useEffect(() => {
    if (mode === "edit") {
      getOldValues()
    }
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getSlideDetails(payload))
  }

  useEffect(() => {
    if (slideDetails && !loading && mode === "edit") {
      const {
        _id,
        imageUrlType,
        imageUrl,
        applySameImageOnBothLang,
        imageUrlTypeAr,
        imageUrlAr,
        displayOrder,
        title,
        titleAr,
        description,
        descriptionAr,
        linkLabel,
        linkLabelAr,
        linkType,
        linkValue,
        hasAdvancedSettings,
        bannerGroup,
        status,
        categoryId,
      } = slideDetails
      setFormValues({
        ...formValues,
        imageType: imageUrlType,
        imageURL: imageUrl,
        imageFile: imageUrl,
        applySameImageOnBothLang: applySameImageOnBothLang,
        imageUrlTypeAr,
        imageUrlAr,
        hasAdvancedSettings,
        title,
        titleAr,
        description,
        descriptionAr,
        linkLabel,
        linkLabelAr,
        linkValue,
        linkType,
        imageAr: "",
        label: "", //need from API
        displayOrder: displayOrder,
        category: categoryId,
        item: linkType === "ITEM" ? linkValue : "",
      })
      // CALL ITEMS API ONLY IF HAVE LINKTYPE = ITEM
      linkType === "ITEM" && allItemsList(categoryId)
    }
  }, [slideDetails])

  const categoriesOptions = allCategories?.map(category => ({
    label: category.name,
    value: category._id,
  }))
  // console.log(allCategories)

  const handleOnSubmit = values => {
    const {
      imageType,
      imageURL,
      imageFile,
      applySameImageOnBothLang,
      imageUrlTypeAr,
      imageUrlAr,
      hasAdvancedSettings,
      title,
      titleAr,
      description,
      descriptionAr,
      linkLabel,
      linkLabelAr,
      linkValue,
      linkType,
      imageAr,
      label,
      displayOrder,
      category,
      item,
    } = values

    const newLinkValues =
      linkType === "CATEGORY" ? category : linkType === "ITEM" ? item : ""
    let data = new FormData()
    data.append("imageUrlType", imageType)
    data.append("imageUrl", imageURL)
    data.append("applySameImageOnBothLang", applySameImageOnBothLang)
    data.append(
      "imageUrlTypeAr",
      applySameImageOnBothLang ? "" : imageUrlTypeAr
    )
    data.append("imageUrlAr", imageUrlAr)
    data.append("hasAdvancedSettings", hasAdvancedSettings)
    data.append("title", title)
    data.append("titleAr", titleAr)
    data.append("description", description)
    data.append("descriptionAr", descriptionAr)
    data.append("linkLabel", linkLabel)
    data.append("linkLabelAr", linkLabelAr)
    data.append("linkValue", newLinkValues)
    data.append("linkType", linkType)
    data.append("image", imageFile)
    data.append("imageAr", imageAr)
    data.append("label", label)
    data.append("displayOrder", displayOrder)
    data.append("bannerGroup", bannerId)
    category && data.append("categoryId", category)

    if (mode === "add") {
      dispatch(addSlide(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate("/banners")
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "edit") {
      data.append("id", id)
      dispatch(updateSlide(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate("/banners")
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const validateImageDimensions = (file, width, height, callback) => {
    const reader = new FileReader()
    reader.onload = e => {
      const img = new Image()
      img.onload = () => {
        callback(img.width === width && img.height === height)
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }

  const handleFileChange = async (event, setFieldValue, fileName) => {
    const file = event.currentTarget.files[0]
    if (file) {
      validateImageDimensions(
        file,
        bannerWidth,
        bannerHeight,
        async isValid => {
          if (isValid) {
            dispatch(setImageCompressing(true)) // Start compressing

            try {
              // Compression options
              const options = {
                maxSizeMB: 0.5,
                maxWidthOrHeight: 1024,
                useWebWorker: true,
              }

              // Compress the image file
              const compressedFile = await imageCompression(file, options)

              // Set the compressed file value
              setFieldValue(fileName, compressedFile)
            } catch (error) {
              console.error("File compression failed:", error)
              setFieldValue(fileName, file) // Use original file if compression fails
            } finally {
              dispatch(setImageCompressing(false)) // End compressing
            }
          } else {
            dispatch(
              showAlert({
                text: `Image dimensions must be ${bannerWidth}x${bannerHeight} pixels.`,
                type: "error",
              })
            )
            event.target.value = ""
            setFieldValue(fileName, null)
          }
        }
      )
    }
  }

  if (mode === "edit" && loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center">
                  <BackButton />
                  {mode === "add" ? t("Add Slide") : t("Edit Slide")}
                </CardTitle>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addSlideSchema}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, errors, touched, setFieldValue }) => (
                    <Form>
                      <div className="row">
                        {values.applySameImageOnBothLang ? (
                          <>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="">{t("Image Type")}</label>
                                <Field
                                  as="select"
                                  id="imageType"
                                  name="imageType"
                                  onChange={e => {
                                    const selectedValue = e.target.value
                                    setFieldValue("imageType", selectedValue)
                                    // Reset the value of imageURL and imageFile when the image type changes
                                    setFieldValue("imageURL", "")
                                    setFieldValue("imageFile", null)
                                  }}
                                >
                                  <option value="URL">{t("Image Url")}</option>
                                  <option value="UPLOAD">
                                    {t("Upload Image")}
                                  </option>
                                </Field>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form_field">
                                {/* IMAGE URL */}
                                {values.imageType === "URL" && (
                                  <div className="form_field">
                                    <label htmlFor="imageURL">
                                      {t("Image URL")}
                                    </label>
                                    <Field
                                      type="text"
                                      id="imageURL"
                                      name="imageURL"
                                      className={`form-control ${
                                        touched.imageURL && errors.imageURL
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                    <TextError name={"imageURL"} />
                                  </div>
                                )}
                                {/* UPLOAD IMAGE */}
                                {values.imageType === "UPLOAD" && (
                                  <div className="form_field position-relative">
                                    <label htmlFor="imageFile">
                                      {t("Upload Image")}
                                    </label>
                                    <input
                                      type="file"
                                      id="imageFile"
                                      name="imageFile"
                                      accept="image/jpeg, image/jpg, image/png"
                                      style={{ padding: 10 }}
                                      className={`form-control ${
                                        touched.imageFile && errors.imageFile
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      onChange={e =>
                                        handleFileChange(
                                          e,
                                          setFieldValue,
                                          "imageFile"
                                        )
                                      }
                                      // onChange={e => {
                                      //   setFieldValue(
                                      //     "imageFile",
                                      //     e.currentTarget.files[0]
                                      //   )
                                      //   // Read uploaded file and set it as image URL for preview
                                      //   const reader = new FileReader()
                                      //   reader.onload = function (event) {
                                      //     setFieldValue(
                                      //       "imageURL",
                                      //       event.target.result
                                      //     )
                                      //   }
                                      //   reader.readAsDataURL(
                                      //     e.currentTarget.files[0]
                                      //   )
                                      // }}
                                    />
                                    {isImageCompressing && (
                                      <Spinner
                                        color="primary"
                                        className="file_upload_btn"
                                      />
                                    )}
                                    <TextError name={"imageFile"} />
                                  </div>
                                )}
                                <span>
                                  {t("Recommended size: {{dimension}}", {
                                    dimension: `${bannerWidth}x${bannerHeight}`,
                                  })}
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="">
                                  {t("Image Type(عربي)")}
                                </label>
                                <Field
                                  as="select"
                                  id="imageUrlTypeAr"
                                  name="imageUrlTypeAr"
                                  onChange={e => {
                                    const selectedValue = e.target.value
                                    setFieldValue(
                                      "imageUrlTypeAr",
                                      selectedValue
                                    )
                                    // Reset the value of imageURL and imageFile when the image type changes
                                    setFieldValue("imageUrlAr", "")
                                    setFieldValue("imageAr", null)
                                  }}
                                >
                                  <option value="URL">{t("Image Url")}</option>
                                  <option value="UPLOAD">
                                    {t("Upload Image")}
                                  </option>
                                </Field>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form_field">
                                {/* IMAGE URL */}
                                {values.imageUrlTypeAr === "URL" && (
                                  <div className="form_field">
                                    <label htmlFor="imageUrlAr">
                                      {t("Image URL(عربي)")}
                                    </label>
                                    <Field
                                      type="text"
                                      id="imageUrlAr"
                                      name="imageUrlAr"
                                      className={`form-control ${
                                        touched.imageUrlAr && errors.imageUrlAr
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                    <TextError name={"imageUrlAr"} />
                                  </div>
                                )}
                                {/* UPLOAD IMAGE */}
                                {values.imageUrlTypeAr === "UPLOAD" && (
                                  <div className="form_field position-relative">
                                    <label htmlFor="imageFile">
                                      {t("Upload Image(عربي)")}
                                    </label>
                                    <input
                                      type="file"
                                      id="imageAr"
                                      name="imageAr"
                                      style={{ padding: 10 }}
                                      className={`form-control ${
                                        touched.imageAr && errors.imageAr
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      accept="image/jpeg, image/jpg, image/png"
                                      onChange={e =>
                                        handleFileChange(
                                          e,
                                          setFieldValue,
                                          "imageAr"
                                        )
                                      }
                                      // onChange={e => {
                                      //   setFieldValue(
                                      //     "imageAr",
                                      //     e.currentTarget.files[0]
                                      //   )
                                      //   // Read uploaded file and set it as image URL for preview
                                      //   const reader = new FileReader()
                                      //   reader.onload = function (event) {
                                      //     setFieldValue(
                                      //       "imageAr",
                                      //       event.target.result
                                      //     )
                                      //   }
                                      //   reader.readAsDataURL(
                                      //     e.currentTarget.files[0]
                                      //   )
                                      // }}
                                    />
                                    {isImageCompressing && (
                                      <Spinner
                                        color="primary"
                                        className="file_upload_btn"
                                      />
                                    )}
                                    <TextError name={"imageAr"} />
                                  </div>
                                )}
                                <span>
                                  {t("Recommended size: {{dimension}}", {
                                     dimension: `${bannerWidth}x${bannerHeight}`
                                  })}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="">
                                  {t("Image Type(English)")}
                                </label>
                                <Field
                                  as="select"
                                  id="imageType"
                                  name="imageType"
                                  onChange={e => {
                                    const selectedValue = e.target.value
                                    setFieldValue("imageType", selectedValue)
                                    // Reset the value of imageURL and imageFile when the image type changes
                                    setFieldValue("imageURL", "")
                                    setFieldValue("imageFile", null)
                                  }}
                                >
                                  <option value="URL">{t("Image Url")}</option>
                                  <option value="UPLOAD">
                                    {t("Upload Image")}
                                  </option>
                                </Field>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form_field">
                                {/* IMAGE URL */}
                                {values.imageType === "URL" && (
                                  <div className="form_field">
                                    <label htmlFor="imageURL">
                                      {t("Image URL(English)")}
                                    </label>
                                    <Field
                                      type="text"
                                      id="imageURL"
                                      name="imageURL"
                                      className={`form-control ${
                                        touched.imageURL && errors.imageURL
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                    <TextError name={"imageURL"} />
                                  </div>
                                )}
                                {/* UPLOAD IMAGE */}
                                {values.imageType === "UPLOAD" && (
                                  <div className="form_field position-relative">
                                    <label htmlFor="imageFile">
                                      {t("Upload Image(English)")}
                                    </label>
                                    <input
                                      type="file"
                                      id="imageFile"
                                      name="imageFile"
                                      style={{ padding: 10 }}
                                      className={`form-control ${
                                        touched.imageFile && errors.imageFile
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      accept="image/jpeg, image/jpg, image/png"
                                      onChange={e =>
                                        handleFileChange(
                                          e,
                                          setFieldValue,
                                          "imageFile"
                                        )
                                      }
                                      // onChange={e => {
                                      //   setFieldValue(
                                      //     "imageFile",
                                      //     e.currentTarget.files[0]
                                      //   )
                                      //   // Read uploaded file and set it as image URL for preview
                                      //   const reader = new FileReader()
                                      //   reader.onload = function (event) {
                                      //     setFieldValue(
                                      //       "imageURL",
                                      //       event.target.result
                                      //     )
                                      //   }
                                      //   reader.readAsDataURL(
                                      //     e.currentTarget.files[0]
                                      //   )
                                      // }}
                                    />
                                    {isImageCompressing && (
                                      <Spinner
                                        color="primary"
                                        className="file_upload_btn"
                                      />
                                    )}
                                    <TextError name={"imageFile"} />
                                  </div>
                                )}
                                <span>
                                  {t("Recommended size: {{dimension}}", {
                                     dimension: `${bannerWidth}x${bannerHeight}`
                                  })}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                        {/* <div className="col-lg-6">
                          {values.imageFile && (
                            <img
                              src={values.imageURL}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </div> */}
                        {/* <div className="col-lg-6">
                          {values.imageAr && (
                            <img
                              src={values.imageUrlAr}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                            />
                          )}
                        </div> */}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="">
                              {t("Apply the same images to both language")}
                            </label>
                            <Switch
                              isChecked={values.applySameImageOnBothLang}
                              onClickHandler={() => {
                                setFieldValue(
                                  "applySameImageOnBothLang",
                                  !values.applySameImageOnBothLang
                                )
                                // setFieldValue("imageFile", null)
                                // setFieldValue("imageAr", null)
                                // setFieldValue("imageURL", "")
                                // setFieldValue("imageUrlAr", "")
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form_field">
                            <label
                              htmlFor=""
                              className="cursor-pointer"
                              onClick={() =>
                                setFieldValue(
                                  "hasAdvancedSettings",
                                  !values.hasAdvancedSettings
                                )
                              }
                            >
                              {t("Advance Settings")}{" "}
                              <i
                                className={`bx bxs-${
                                  values.hasAdvancedSettings ? "up" : "down"
                                }-arrow`}
                              ></i>
                            </label>
                          </div>
                        </div>

                        {/* SHOW BELOW FIELD IF HAVE hasAdvancedSettings */}
                        {values.hasAdvancedSettings && (
                          <>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="titleAr">
                                  {t("Title(عربي)")}
                                </label>
                                <Field
                                  type="text"
                                  id="titleAr"
                                  name="titleAr"
                                  style={{ direction: "rtl" }}
                                  className={`form-control ${
                                    touched.titleAr && errors.titleAr
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder={t("Title(عربي)")}
                                />
                                <TextError name={"titleAr"} />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="title">
                                  {t("Title(English)")}
                                </label>
                                <Field
                                  type="text"
                                  id="title"
                                  name="title"
                                  className="form-control"
                                  placeholder={t("Title(English)")}
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="descriptionAr">
                                  {t("Description(عربي)")}
                                </label>
                                <Field
                                  as="textarea"
                                  id="descriptionAr"
                                  name="descriptionAr"
                                  rows={1}
                                  placeholder={t("Description(عربي)")}
                                  style={{ direction: "rtl" }}
                                  className={`form-control ${
                                    touched.descriptionAr &&
                                    errors.descriptionAr
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name={"descriptionAr"} />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="description">
                                  {t("Description(English)")}
                                </label>
                                <Field
                                  as="textarea"
                                  id="description"
                                  name="description"
                                  rows={1}
                                  placeholder={t("Description(English)")}
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="linkLabelAr">
                                  {t("Link Label(عربي)")}
                                </label>
                                <Field
                                  type="text"
                                  id="linkLabelAr"
                                  placeholder={t("Link Label(عربي)")}
                                  name="linkLabelAr"
                                  style={{ direction: "rtl" }}
                                  className={`form-control ${
                                    touched.linkLabelAr && errors.linkLabelAr
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name={"linkLabelAr"} />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="linkLabel">
                                  {t("Link Label(English)")}
                                </label>
                                <Field
                                  type="text"
                                  id="linkLabel"
                                  name="linkLabel"
                                  placeholder={t("Link Label(English)")}
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="linkType">
                                  {t("Link this banner to")}
                                </label>
                                <Field
                                  as="select"
                                  id="linkType"
                                  name="linkType"
                                  onChange={e => {
                                    const selectedValue = e.target.value
                                    setFieldValue("linkType", selectedValue)
                                    if (selectedValue === "ITEM") {
                                      // allItemsList()
                                    }
                                    setFieldValue("item", "")
                                    setFieldValue("category", "")
                                  }}
                                >
                                  <option hidden>{t("Select Options")}</option>
                                  {/* <option value="LINK">Link</option> */}
                                  <option value="CATEGORY">
                                    {t("Category")}
                                  </option>
                                  <option value="ITEM">{t("Item")}</option>
                                </Field>
                              </div>
                            </div>

                            {(values.linkType === "CATEGORY" ||
                              values.linkType === "ITEM") && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="">
                                    {t("Select Category")}
                                  </label>

                                  <Field
                                    as="select"
                                    id="category"
                                    name="category"
                                    onChange={e => {
                                      const { value } = e.target
                                      setFieldValue("item", "")
                                      allItemsList(value)
                                      setFieldValue("category", value)
                                    }}
                                  >
                                    <option hidden>
                                      {t("Select Category")}
                                    </option>

                                    {allCategories &&
                                      allCategories.map(option => (
                                        <option
                                          key={option._id}
                                          value={option._id}
                                        >
                                          {language === "sa"
                                            ? option.nameAr
                                            : option.name}
                                        </option>
                                      ))}
                                  </Field>
                                </div>
                              </div>
                            )}

                            {values.category && values.linkType === "ITEM" && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="label">
                                    {t("Select Item")}
                                  </label>
                                  <Field as="select" id="item" name="item">
                                    <option hidden>{t("Select Item")}</option>

                                    {itemsListDropdown &&
                                      itemsListDropdown.map(option => (
                                        <option
                                          key={option._id}
                                          value={option._id}
                                        >
                                          {language === "sa"
                                            ? option.nameAr
                                            : option.name}
                                        </option>
                                      ))}
                                  </Field>
                                </div>
                              </div>
                            )}

                            {/* {values.linkType === "ITEM" && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="label">Select Item</label>
                                  <Field as="select" id="item" name="item">
                                    <option hidden>Select Item</option>

                                    {itemsListDropdown &&
                                      itemsListDropdown.map(option => (
                                        <option
                                          key={option._id}
                                          value={option._id}
                                        >
                                          {option.name}
                                        </option>
                                      ))}
                                  </Field>
                                </div>
                              </div>
                            )} */}

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="label">{t("Label")}</label>
                                <Field
                                  type="text"
                                  id="label"
                                  name="label"
                                  placeholder={t("Label")}
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="displayOrder">
                                  {t("Display Order")}
                                </label>
                                <Field
                                  type="number"
                                  id="displayOrder"
                                  name="displayOrder"
                                  placeholder={t("Display Order")}
                                  className={`form-control ${
                                    touched.displayOrder && errors.displayOrder
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name={"displayOrder"} />
                              </div>
                            </div>
                          </>
                        )}

                        <div className="col-lg-12">
                          <div className="d-flex justify-content-end mt-3">
                            <Button
                              type="button"
                              color="secondary"
                              className="mx-2"
                            >
                              <Link to="/banners" className="text-white ">
                                {t("Cancel")}
                              </Link>
                            </Button>
                            <Button
                              color="success"
                              type="submit"
                              disabled={
                                isLoading || isUpdating || isImageCompressing
                              }
                            >
                              {mode === "add" ? t("Add") : t("Save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddSlide
